// TODO: Polyfill Array.isArray
function debounce(fn, t, immediate) {
    var timer;
    return function () {
        var thisArg = this, args = arguments;
        var noTimer = !timer;
        clearTimeout(timer);
        timer = setTimeout(function () {
            timer = null;
            if (!immediate && typeof fn === "function")
                fn.apply(thisArg, args);
        }, t);
        if (immediate && noTimer && typeof fn === "function")
            fn.apply(thisArg, args);
    };
}
function _extend(deep, obj, obj2) {
    if (typeof obj !== "object" || typeof obj2 !== "object")
        return;
    for (var prop in obj2) {
        if (Object.prototype.hasOwnProperty.call(obj2, prop)) {
            if (deep && typeof obj2[prop] === "object") {
                if (Array.isArray(obj2[prop]))
                    obj[prop] = [];
                else
                    obj[prop] = {};
                _extend(deep, obj[prop], obj2[prop]);
            }
            else {
                obj[prop] = obj2[prop];
            }
        }
    }
}
function extend(deep, obj) {
    var args = Array.prototype.slice.call(arguments, 0);
    if (typeof deep === "object") {
        obj = deep;
        deep = false;
        args.splice(0, 1);
    }
    else {
        deep = !!deep;
        args.splice(0, 2);
    }
    if (typeof obj !== "object")
        throw new Error("Object that you are extending, must be an object");
    for (var i = 0; i < args.length; i++) {
        _extend(deep, obj, args[i]);
    }
    return obj;
}
function formatStr(template, vars) {
    return template.replace(/\{(\w+)\}/gi, function (pattern, varName) {
        return (vars && vars[varName]) || "";
    });
}
function inherits(A, B) {
    var A_Proto = function () { };
    A_Proto.prototype = B.prototype;
    A.prototype = new A_Proto();
    A.prototype.constructor = A;
}
function cloneObj(obj) {
    var ret = {};
    for (var prop in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, prop))
            ret[prop] = obj[prop];
    }
    return ret;
}
function isArray(obj) {
    return Object.prototype.toString.call(obj) === "[object Array]";
}
function bind(fn, thisObj, args) {
    return function () {
        return fn.apply(thisObj, args || arguments);
    };
}
function objectCreate(p) {
    var A = function () { };
    A.prototype = p;
    var ret = new A();
    A.prototype = null;
    return ret;
}
function getOption(opts, prop, def) {
    if (typeof opts !== "object" || typeof opts[prop] === "undefined")
        return def;
    return opts[prop];
}
function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function defineComputedProp(obj, name, resolveValue) {
    var privateName = "_" + name;
    Object.defineProperty(obj, name, {
        configurable: true,
        enumerable: true,
        get: function () {
            return resolveValue.call(this, this.__cursor, this[privateName]);
        },
        set: function (v) {
            this[privateName] = v;
        }
    });
}
function definePercentageProp(obj, name, resolvePct) {
    defineComputedProp(obj, name, function (cursor, privateValue) {
        if (privateValue && hasOwnProperty(privateValue, "pct")) {
            if (!cursor)
                throw new Error("Can't calulate percentage for '" + name + "'! Cursor is not defined!");
            return resolvePct(cursor, privateValue.pct);
        }
        return privateValue;
    });
}
function CalcCache() {
    this.cache = {};
}
CalcCache.prototype.hash = function (key) {
    if (typeof key === "undefined" || typeof key === "function")
        throw new TypeError("cache key cannot be undefined or a function");
    if (typeof key === "object")
        return JSON.stringify(key);
    else
        return key;
};
CalcCache.prototype.has = function (key) {
    key = this.hash(key);
    var v = this.cache[key];
    return v !== null && typeof v !== "undefined";
};
CalcCache.prototype.get = function (key) {
    return this.cache[this.hash(key)];
};
CalcCache.prototype.set = function (key, value) {
    this.cache[this.hash(key)] = value;
};
CalcCache.prototype.clear = function () {
    this.cache = {};
};
module.exports = {
    getOption: getOption,
    debounce: debounce,
    extend: extend,
    formatStr: formatStr,
    inherits: inherits,
    clone: cloneObj,
    cloneObj: cloneObj,
    isArray: isArray,
    bind: bind,
    objectCreate: objectCreate,
    CalcCache: CalcCache,
    hasOwnProperty: hasOwnProperty,
    definePercentageProp: definePercentageProp
};
//# sourceMappingURL=module.js.map